<template>
  <AccountPanel title="Faktury">
    <div v-if="badInvoice" class="alert alert-danger" role="alert">Brak faktury!</div>
    <div class="row">
      <div class="invoices-total col-12 mb-2">
        <span class="label">Suma niespłaconych faktur:</span>
        <span class="text-info">{{calculateUnpaid()}}</span>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">nr faktury</th>
          <th scope="col">data wystawienia</th>
          <th scope="col">netto</th>
          <th scope="col">brutto</th>
          <th scope="col">termin płatności</th>
          <th scope="col">status</th>
          <th scope="col">akcje</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="o in company.invoices">
          <td>
            <span class="user-mobile-label">nr faktury</span>
            <span>{{o.number}}</span>
          </td>
          <td>
            <span class="user-mobile-label">data wystawienia</span>
            <span>{{o.added}}</span>
          </td>
          <td>
            <span class="user-mobile-label">netto</span>
            <span>{{formatPrice(o.netto)}}</span>
          </td>
          <td>
            <span class="user-mobile-label">brutto</span>
            <span>{{formatPrice(o.price)}}</span>
          </td>
          <td>
            <span class="user-mobile-label">termin płatności</span>
            <span>{{o.paid_date}}</span>
          </td>
          <td>
            <span class="user-mobile-label">status</span>
            <span>{{statuS(o.cost)}}</span>
          </td>
          <td>
            <button class="btn btn-secondary show-invoice-button" @click="redirectPdf(o)">
              <span>Wyświetl fakturę</span>
              <FileDocumentIcon title="wyświetl fakturę" class="pull-right" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      align="right"
      :total-rows="company.invoicesCount"
      v-model="current"
      :per-page="limit"
    ></b-pagination>
  </AccountPanel>
</template>


<script>
import { mapState } from "vuex";
import AccountPanel from "./AccountPanel.vue";
import FileDocumentIcon from "vue-material-design-icons/FileDocument.vue";
import ApiClient from "./../../../api/src/ApiClient";
import md5 from "md5.js";
import { BPagination } from "./../../../BootstrapElements";

export default {
  components: {
    AccountPanel,
    FileDocumentIcon,
    md5,
    BPagination
  },
  data() {
    return {
      limit: 20,
      offset: 1,
      current: 1,
      order: "added desc",
      orderOptions: [
        { value: "added desc", text: "Najnowszej" },
        { value: "added asc", text: "Najstarszej" },
        { value: "payment desc", text: "Termin płatności malejąco" },
        { value: "payment asc", text: "Termin płatności rosnąco" },
        { value: "price desc", text: "Najwyższej kwoty" },
        { value: "price asc", text: "Najniższej kwoty" }
      ],
      status: 0,
      statusOptions: [
        { value: 0, text: "wszytkie" },
        { value: 1, text: "zapłacone / rozliczone" },
        { value: 2, text: "do zapłaty / do rozliczenia" }
      ],
      badInvoice: false
    };
  },
  computed: {
    ...mapState({
      company: state => state.company
    })
  },
  watch: {
    status: function(value) {
      this.$store.dispatch("company/invoicesCount", { type: this.status });
    }
  },

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    statuS(cost) {
      return cost <= 0 ? "zapłacona" : "do zapłaty";
    },
    redirectPdf(item) {
      let shop_id = "13118";
      let hash = md5(`${item.number}-${shop_id}-MegaTajnyHash`);
      // if(data>0) {
      let url =
        "https://eskulap.redbay.pl/pl/shop/orders/getinvoice?name=" +
        item.number +
        "&sid=" +
        shop_id +
        "&hash=" +
        hash;
      window.open(url, "_blank");
      // } else {
      //   this.badInvoice = true;
      //   window.scrollTo(0,0);
      //   setTimeout(() => {
      //     this.badInvoice = false;
      //   }, 5000);
      // }
      // ApiClient.get('api/company/invoiceOrderId?invoiceNumber='+item.number).then( data => {
      //   console.log(data);
      // })
    },
    calculateUnpaid() {
      let total = 0;
      let keys = Object.keys(this.company.invoices);
      for (let key of keys) {
        if (this.company.invoices[key].price > 0) {
          total += this.company.invoices[key].price;
        }
      }
      return `${total} ${this.company.currencies[this.company.selectedCurrencyKey].currency.symbol}`;
    }
  },

  beforeMount() {
    this.$store.dispatch("company/invoicesCount", { type: this.status });
    this.$store.dispatch("company/invoiceList", {
      limit: this.limit,
      offset: this.offset
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/InvoicePage.vue